import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Locality from '../../models/Locality'

export interface LocalityListState extends PaginatedApiState {
  localities?: Locality[]
}

const LocalityList = (state: LocalityListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<LocalityListState>('LOCALITY_LIST')(state, action)
  }
}

export default LocalityList
